export default "__VITE_ASSET__Bp9cnCiX__"